import { UserManager } from 'oidc-client-ts';

import { userManagerConfig } from 'src/config/userManagerConfig';

export const userManager = new UserManager(userManagerConfig);
